// Imported through Vite so the files land in /assets/* with hashed names —
// the only path the CF Pages _headers file serves with immutable caching
// (everything under public/ is no-store, which re-downloaded the wordmark on
// every refresh).
import logoDark from '@/assets/brand/logo-dark.svg'
import logoLight from '@/assets/brand/logo-light.svg'
import { useComponentTranslation } from '@/hooks/use-component-translation'
import { useThemeStore } from '@/stores/theme'

import locales from './locales'

interface SignaterRectangleLogoProps {
  className?: string
  height?: number
  /**
   * Pins the asset to a surface brightness instead of the app theme. The auth
   * brand field is dark in both themes, so it needs the white wordmark even
   * when the app is in light mode.
   */
  forceTheme?: 'light' | 'dark'
}

export function getSignaterRectangleLogoSrc(theme: 'light' | 'dark') {
  return theme === 'dark' ? logoDark : logoLight
}

export function SignaterRectangleLogo({
  className,
  height = 32,
  forceTheme,
}: SignaterRectangleLogoProps) {
  const { t } = useComponentTranslation(locales)
  const theme = useThemeStore((state) => state.theme)

  const logoSrc = getSignaterRectangleLogoSrc(forceTheme ?? theme)

  return (
    <img
      src={logoSrc}
      alt={t('alt')}
      className={className}
      style={{ height, width: 'auto' }}
    />
  )
}
